import React, { Component } from 'react';
import Button from '../button/Button';
export default class PrimaryButton extends Component {
	render() {
		return <Button color="white" bg="blue" {...this.props} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/primaryButton/PrimaryButton.jsx